import currencySelectors from './currencies'
import { documentStatsSelectors } from './documentStats'
import expenseCategorySelectors from './expenseCategories'
import fileUploadSelectors from './fileUpload'
import { filterSelectors } from './filters'
import formSelectors from './forms'
import glCodeSelectors from './glCodes'
import jobCodeSelectors from './jobCodes'
import ledgerselectors from './ledger'
import passwordResetSelectors from './passwordReset'
import paymentMethodSelectors from './paymentMethods'
import preferencesSelectors from './preferences'
import reportSelectors from './reports'
import searchVendorSelectors from './searchVendors'
import signupSelectors from './signup'
import tagsSelectors from './tags'
import userSelectors from './user'
import userManagementSelectors from './userManagement'
import vendorSelectors from './vendor'
import { vendorsSelectors } from './vendors'
import inboxEmailsSelectors from './inboxEmails'
import workFlowStatusesSelectors from './workFlowStatuses'
import sourceSelectors from './sources'
import reconciliationSelectors from './reconciliation'
import dataIntegrationSelectors from './dataIntegration'
import propertyNamesSelectors from './propertyNames'
import departmentSelectors from './department'
import unitNoSelectors from './unitNo'
import entitySelectors from './entity'
import purchaseOrdersSelectors from './purchaseOrders'

const selectors = {
  ...currencySelectors,
  ...documentStatsSelectors,
  ...expenseCategorySelectors,
  ...fileUploadSelectors,
  ...filterSelectors,
  ...formSelectors,
  ...glCodeSelectors,
  ...jobCodeSelectors,
  ...ledgerselectors,
  ...passwordResetSelectors,
  ...paymentMethodSelectors,
  ...preferencesSelectors,
  ...reportSelectors,
  ...searchVendorSelectors,
  ...signupSelectors,
  ...tagsSelectors,
  ...userSelectors,
  ...userManagementSelectors,
  ...vendorSelectors,
  ...vendorsSelectors,
  ...inboxEmailsSelectors,
  ...workFlowStatusesSelectors,
  ...sourceSelectors,
  ...reconciliationSelectors,
  ...dataIntegrationSelectors,
  ...propertyNamesSelectors,
  ...departmentSelectors,
  ...unitNoSelectors,
  ...entitySelectors,
  ...purchaseOrdersSelectors,
}

export default selectors
